import React from 'react'
import ReactDOM from 'react-dom';

export default class DropDown extends React.Component {

    constructor(props){
        super(props)
        this.toggleActive = this.toggleActive.bind(this)
        this.state = {
            active:false
        }
    }
    render(){
        return (
            <div className='dropdown-2 '>
                <button type="button" onClick={this.toggleActive} className="dropdown-2--title dropdown-2 btn-1  btn--small">{this.props.title}</button>
                <div className={`dropdown-2--body  ${(this.state.active?'active':'')}`}>
                    {this.props.children}
                </div>
            </div>
        )
    }

    toggleActive(){
        this.setState({active:!this.state.active})
    }



    componentDidMount() {
        document.addEventListener('click', this.handleClickOutside.bind(this), true);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside.bind(this), true);
    }

    handleClickOutside(event) {
        const domNode = ReactDOM.findDOMNode(this);
        if(this.state.active){
            if ((!domNode || !domNode.contains(event.target)) ) {
                this.toggleActive();
            }
        }
    }

}